import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "pkm_lang";

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
        return saved === "es" ? "es" : "en";
    });

    useEffect(() => {
        try { localStorage.setItem(STORAGE_KEY, lang); } catch (_) { /* ignore */ }
        if (typeof document !== "undefined") {
            document.documentElement.lang = lang;
        }
    }, [lang]);

    const t = (key) => {
        const dict = translations[lang] || translations.en;
        return key.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), dict) ?? key;
    };

    const toggle = () => setLang((p) => (p === "en" ? "es" : "en"));

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
    return ctx;
}
